import {ClientError} from 'graphql-request';
import Router from '@/router/Router';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {getGqlErrorDetailData} from './api/request';
import {AirbridgeInit} from './components/Airbridge';
import {DeviceInit} from './components/DeviceInit';
import {Toaster} from './components/HotToast';

declare global {
  interface Window {
    soho: any; // LG U+ 앱 javascript name
    androidBackPress?: () => void;
    ChannelIO?: (...args: any[]) => void; // 채널톡 (public/index.html 에서 boot)
  }
}

const retry = (failureCount: number, error: ClientError | any) => {
  const extension = getGqlErrorDetailData(error);

  if (extension?.extra?.retry && failureCount < 2) {
    return true;
  }
  return false;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DeviceInit />
      <AirbridgeInit />
      <Router />
      <Toaster />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
